export default __webpack_public_path__ + "static/media/gallery-img05.fb63485b.jpg";